<div>

  <svg
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 9 9"
  xmlns="http://www.w3.org/2000/svg"
  [style.opacity]="opacity"
>
  <!-- Gradient ONLY if colors exist -->
  @if(hasGradient){
    <defs>
      <linearGradient
        [attr.id]="gradientId"
        gradientUnits="userSpaceOnUse"
        x1="0" y1="0"
        x2="9" y2="9"
      >
        <stop offset="0%" [style.stop-color]="startColor" />
        <stop offset="100%" [style.stop-color]="endColor" />
      </linearGradient>
    </defs>
  }

  <path d="M7 0H2C0.895 0 0 0.895 0 2V7C0 8.105 0.895 9 2 9H8C8.555 9 9 8.555 9 8V3C9 2.73478 8.89464 2.48043 8.70711 2.29289C8.51957 2.10536 8.26522 2 8 2V1C8 0.734784 7.89464 0.48043 7.70711 0.292893C7.51957 0.105357 7.26522 0 7 0ZM7 1V2H2C1.635 2 1.295 2.1 1 2.27V2C1 1.45 1.45 1 2 1M6.25 6.25C5.835 6.25 5.5 5.915 5.5 5.5C5.5 5.085 5.835 4.75 6.25 4.75C6.665 4.75 7 5.085 7 5.5C7 5.915 6.665 6.25 6.25 6.25Z"
    [attr.fill]="hasGradient ? 'url(#' + gradientId + ')' : defaultColor"
  />
</svg>

</div>
